module.exports = __webpack_public_path__ + "static/media/Rectangle7857-1.24afbee9.png";